import { createStore } from 'vuex';
import {formModule} from './modules/formModule';
import {currencyModule} from './modules/currencyModule';
import {validityCheckModule} from './modules/validityCheckModule';
import { flagSrc } from '../utils/flagSrc.js';

function normalizeLangFlag(lang) {
    if (!lang || typeof lang !== 'object') return lang;
    if (!lang.flag) return lang;
    return { ...lang, flag: flagSrc(lang.flag) };
}

function normalizeLanguagesFlags(languages) {
    if (!Array.isArray(languages)) return [];
    return languages.map(normalizeLangFlag);
}

const SECOND_HOME_CURRENCY_KEY = 'evh_hide_currency_second_home';

function syncLangIdToLocalStorage(lang) {
    if (typeof localStorage === 'undefined' || lang == null || lang.id == null) return;
    localStorage.setItem('langId', String(lang.id));
}

function resolveHideCurrencySelector(data) {
    if (typeof sessionStorage === 'undefined') {
        return Boolean(data?.isSecondHomePage);
    }

    if (data?.isSecondHomePage) {
        sessionStorage.setItem(SECOND_HOME_CURRENCY_KEY, '1');
        return true;
    }

    return sessionStorage.getItem(SECOND_HOME_CURRENCY_KEY) === '1';
}

export default createStore({
    modules: {
        form: formModule,
        currency: currencyModule,
        validityCheck: validityCheckModule
    },
    state: {
        project: null,
        page: null,
        texts: {},
        lang: null,
        languages: [],
        currencies: [],
        defPath: '/',
        mobileView: false,
        hideCurrencySelector: false
    },
    getters: {
        project: state => state.project,
        page: state => state.page,
        texts: state => state.texts,
        lang: state => state.lang,
        languages: state => state.languages,
        currencies: state => state.currencies,
        currency: (state, getters) => getters['currency/currentCurrency'],
        defPath: state => state.defPath,
        mobileView: state => state.mobileView,
        hideCurrencySelector: state => state.hideCurrencySelector
    },
    mutations: {
        SET_PROJECT(state, project) {
            state.project = project;
        },
        SET_PAGE(state, page) {
            state.page = page;
        },
        SET_TEXTS(state, texts) {
            state.texts = texts;
        },
        SET_LANG(state, lang) {
            state.lang = normalizeLangFlag(lang);
        },
        SET_LANGUAGES(state, languages) {
            state.languages = normalizeLanguagesFlags(languages);
        },
        SET_CURRENCIES(state, currencies) {
            state.currencies = currencies;
        },
        SET_DEF_PATH(state, defPath) {
            state.defPath = defPath;
        },
        INIT_STATE(state, data) {
            state.project = data.project || null;
            state.page = data.page || null;
            state.texts = data.texts || {};
            state.lang = normalizeLangFlag(data.lang || null);
            state.languages = normalizeLanguagesFlags(data.languages || []);
            state.currencies = data.currencies || [];
            state.defPath = data.defPath || '/';
            state.mobileView = data.mobileView || false;
            state.hideCurrencySelector = resolveHideCurrencySelector(data);
        }
    },
    actions: {
        initState({ commit, dispatch }, data) {
            commit('INIT_STATE', data);
            syncLangIdToLocalStorage(data?.lang);
            dispatch('currency/initCurrency', null, { root: true });
        }
    }
});
